import { useState } from "react";

function Playlist({
  queue,
  setQueue,
  current,
  setCurrent,
  setPlaying,
  liked,
  close,
  viewLiked,
  setViewLiked,
}) {
  const [dragIndex, setDragIndex] = useState(null);

  // Defensive: ensure array of objects
  const audioList = Array.isArray(queue) ? queue.filter(Boolean) : [];

  const playAudio = (index) => {
    setCurrent(index);
    setPlaying(true);
  };

  // ==========================
  // Drag & Drop (queue only)
  // ==========================
  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (index === dragIndex) return;

    const newQueue = [...audioList];
    const [moved] = newQueue.splice(dragIndex, 1);
    newQueue.splice(index, 0, moved);

    setDragIndex(index);
    setQueue(newQueue);
  };

  const removeAudio = (index) => {
    const newQueue = [...audioList];
    newQueue.splice(index, 1);

    // If removing current audio
    if (index === current) {
      setCurrent(0);
      setPlaying(false);
    }

    // If removing a audio before current, shift index
    if (index < current) {
      setCurrent((c) => Math.max(c - 1, 0));
    }

    setQueue(newQueue);
  };

  // ==========================
  // Filter liked if needed
  // ==========================
  const displayAudioList = viewLiked
    ? audioList.filter((s) => liked.includes(s.id))
    : audioList;

  return (
    <div className="playlist">
      {/* HEADER */}
      <div className="playlist-header">
        <h3>{viewLiked ? "Liked Reciters" : "Playlist"}</h3>
        <div className="playlist-actions">
          <button onClick={() => setViewLiked(!viewLiked)}>
            {viewLiked ? "Playlist" : "Liked"}
          </button>
          {/* <button onClick={close}>✕</button> */}
        </div>
      </div>

      {/* LIST */}
      <div className="playlist-list">
        {displayAudioList.length === 0 && <p className="empty">No audio</p>}

        {displayAudioList.map((audio, index) => (
          <div
            key={audio.id}
            className={`playlist-item ${index === current ? "active" : ""}`}
            draggable={!viewLiked}
            onDragStart={() => handleDragStart(index)}
            onDragOver={(e) => !viewLiked && handleDragOver(e, index)}
            onClick={() => playAudio(index)}
          >
            {!viewLiked && (
              <span className="drag-handle" title="Drag to reorder">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <circle cx="9" cy="5" r="1.5" />
                  <circle cx="15" cy="5" r="1.5" />
                  <circle cx="9" cy="12" r="1.5" />
                  <circle cx="15" cy="12" r="1.5" />
                  <circle cx="9" cy="19" r="1.5" />
                  <circle cx="15" cy="19" r="1.5" />
                </svg>
              </span>
            )}

            <img src={audio.cover} alt="" />

            <div className="playlist-info">
              <span className="title">{audio.title}</span>
              <span className="riwaya">({audio.riwaya})</span>
              <div className="reciter">{audio.reciter}</div>
            </div>

            {liked.includes(audio.id) && <span>❤️</span>}

            <button
              className="remove-btn"
              onClick={(e) => {
                e.stopPropagation();
                removeAudio(index);
              }}
              disabled={viewLiked}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Playlist;
